import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import FitAssistant from './FitAssistant.tsx';
import store from './Store/store.ts';
import * as Sentry from '@sentry/react';

const rootElement = document.getElementById('REACT_FitAssistant_new');

if (rootElement) {
  let root = createRoot(rootElement);
  root.render(
    <Provider store={store}>
      <Sentry.ErrorBoundary>
        <FitAssistant />
      </Sentry.ErrorBoundary>
    </Provider>
  );
}
